import { render, staticRenderFns } from "./AgreePaymentRuleForm.vue?vue&type=template&id=1036d740&scoped=true&"
import script from "./AgreePaymentRuleForm.vue?vue&type=script&lang=js&"
export * from "./AgreePaymentRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036d740",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VTextarea})
